import {
  Accordion,
  AccordionItem,
  AccordionButton,
  Box,
  AccordionPanel,
  AccordionIcon,
  Icon,

} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import ReactPixel from "react-facebook-pixel";
import Quantity from "../components/Quantity";
import {
  useParams,
  useLocation,
  Link as RouterLink,
  useNavigate,
} from "react-router-dom";
import React, { useState, useEffect } from "react";

import { PRODUCT_REVIEW_CREATE_RESET } from "../constants/productConstants";
import {
  listProductDetails,
  relatedListProducts,
  ymalListProducts,
} from "../actions/productActions";
import { addItemToCart } from "../actions/cartActions";
import {
  addItemToWishlist,
  getWishlistItems,
  removeItemFromWishlist,
} from "../actions/wishListActions";
import { toast } from "react-toastify";
import "../components/productImageSlider.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import PromoProductCard from "../components/PromoProductList";
import { serverIp } from "../config/conf";
import axios from "axios";
import {
  AiFillHeart,
  AiOutlineHeart,
  AiOutlineShoppingCart,
} from "react-icons/ai";
import { Helmet } from "react-helmet";
import { FaRegEdit } from "react-icons/fa";
import { listSizes } from "../actions/sizeActions";
import ProductImages from "../components/ProductImages";
import ShareButton from "../components/ShareButton";
import ProductSet2 from "../components/ProductSet2";
import FeatureBanner from "../components/FeatureBanner";
import AnkletSizeSelector from "../components/AnkletSizeSelector";
import BraceletSizeSelector from "../components/BraceletSizeSelector";
import RingSizeSelector from "../components/RingSizeSelector";
import PetEngraving from '../components/petEngraving';
import EngravingSection from "../components/EngravingSection";
import WishlistToggleButton from "../components/WishlistButton";



export default function ProductPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const routePath = useLocation();
  const onTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    onTop();
  }, [routePath]);

  const queryParams = new URLSearchParams(routePath.search);
  let variantId = queryParams.get("variant");

  const { id } = useParams();
  const [qty, setQty] = useState(1);
  const [isPair, setIsPair] = useState(false);

  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [mainImg, setMainImg] = useState(0);
  // const { isOpen, onOpen, onClose } = useDisclosure();
  const [zoom, setZoom] = useState(1);
  const [isZoomed, setIsZoomed] = useState(false);
  const [imagePosition, setImagePosition] = useState({ x: 0, y: 0 });
  const [engravingTextMen, setEngravingTextMen] = useState(""); // State for engraving text
  const [engravingTextWomen, setEngravingTextWomen] = useState(""); // State for engraving text
  const [isAccordionOpen, setIsAccordionOpen] = useState(false); // State to track Accordion state
  const [selectedSizeMen, setSelectedSizeMen] = useState(0);
  const [selectedSizeWomen, setSelectedSizeWomen] = useState(0);
  const [productSet, setProductSet] = useState([]);

  const [selectedBraceletSizeMen, setSelectedBraceletSizeMen] = useState("");
  const [selectedBraceletSizeWomen, setSelectedBraceletSizeWomen] =
    useState("");

  const [selectedAnkletSize, setSelectedAnkletSize] =
    useState("");

  const [allowRingSize, setAllowRingSize] = useState(false);
  const [allowAnkletType, setAllowAnkletType] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItemBasePrice, setSelectedItemBasePrice] = useState([]);
  const [price, setPrice] = useState(0);
  const [basePrice, setBasePrice] = useState(0);
  const [allowBraceletSize, setAllowBraceletSize] = useState(false);

  const handleEngravingInput = (value, gender) => {
    const lettersAndSpaces = /^[A-Za-z ]*$/; // Regex to allow only letters and spaces
    if (lettersAndSpaces.test(value)) {
      if (gender === "female" || gender === "unisex") {
        setEngravingTextWomen(value); // Update engraving text if input is valid
      } else {
        setEngravingTextMen(value); // Update engraving text if input is valid
      }
    }
  };

  const handleAccordionToggle = (isOpen) => {
    setIsAccordionOpen(isOpen); // Toggle Accordion state
    if (!isOpen) {
      setEngravingTextMen(""); // Clear engraving text when Accordion is closed
      setEngravingTextWomen(""); // Clear engraving text when Accordion is closed
    }
  };

  const [selectedColor, setSelectedColor] = useState("Yellow");

  // const [isOpen2, setIsOpen] = useState(false);
  const [isCustomized, setIsCustomized] = useState(false);
  const [numberOfCustomFields, setNumberOfCustomFields] = useState(0);

  const [customQuestions, setCustomQuestions] = useState([]);
  const [userResponses, setUserResponses] = useState([]);

  const [name1, setName1] = useState("");
  const [name2, setName2] = useState("");

  const handleColorChange = (name, sku, color) => {
    navigate(`/product/${name?.replaceAll(" ", "-")}/${sku}`);
    setSelectedColor(color);
  };

  const [pinCode, setPinCode] = useState("");
  const [isDeliveryAvailable, setIsDeliveryAvailable] = useState(null);

  const [isDragging, setIsDragging] = useState(false);

  let [isOpen, setIsOpen] = useState(false);
  let [isCalculator, setIsCalculator] = useState(false);
  let [isBraceletSize, setIsBraceletSize] = useState(false);
  let [isAnkletSize, setIsAnkletSize] = useState(false);

  const uploadImageHandler = async (e, setImageCallback) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);
    // setUploading(true);

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await axios.post(
        `${serverIp}/api/uploads/single`,
        formData,
        config
      );

      // Use the passed callback to set the image URL
      setImageCallback(data);

      // setUploading(false);
    } catch (err) {
      console.error(err);
      // setUploading(false);
    }
  };

  function closeModal() {
    // dispatch(logout())
    setIsOpen(false);
  }

  const handleMouseDown = () => {
    setIsDragging(true);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  function closeModal() {
    setIsOpen(false);
  }

  function calculatorcloseModal() {
    setIsCalculator(false);
  }

  function closeBraceletModal() {
    setIsBraceletSize(false);
  }

  function closeAnkletModal() {
    setIsAnkletSize(false);
  }

  const handleDragMove = (e) => {
    if (isDragging) {
      const image = e.target;
      const imageRect = image.getBoundingClientRect();
      const x = ((e.clientX - imageRect.left) / imageRect.width) * 100;
      const y = ((e.clientY - imageRect.top) / imageRect.height) * 100;
      setImagePosition({ x, y });
    }
  };

  const handleMouseOver = () => {
    setZoom(2.5);
    setIsZoomed(true);
  };

  const wishList = useSelector((state) => state.wishlist);
  const { wishlistItems, successRemove, successAdd } = wishList;

  const productDetails = useSelector((state) => state.productDetails);
  const { loading, error, product } = productDetails;

  // console.log('product',product?.sku.includes('SAIA'));

  // const [products,setProducts] = useState(product.products);
  // console.log(product.setItemsPer);

  const productReviewCreate = useSelector((state) => state.productReviewCreate);
  const { success: successProductReview, error: errorProductReview } =
    productReviewCreate;

  const relatedProductList = useSelector((state) => state.relatedProductList);
  const {
    loading: loadingRelated,
    error: errorRelated,
    relatedProducts: productsRelated,
  } = relatedProductList;

  const ymalProductList = useSelector((state) => state.ymalProductList);
  const {
    loading: loadingYmal,
    error: errorYmal,
    products: productsYmal,
  } = ymalProductList;

  const sizeList = useSelector((state) => state.sizeList);
  const { loading: loadingSize, error: errorSize, sizes } = sizeList;

  const [scrolling, setScrolling] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setScrolling(true);
    } else {
      setScrolling(false);
    }
  };

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const [finalAmount, setfinalAmount] = useState(0);
  const [itemPer, setItemPer] = useState(0);
  // const [totalPrice, setTotalPrice] = useState(0);
  // const [totalBasePrice, setTotalBasePrice] = useState(0);

  useEffect(() => {
    if (wishlistItems && wishlistItems?.length > 0) {
      if (wishlistItems?.some((item) => !item._id)) {
        dispatch(getWishlistItems());
      }
    }
  }, [wishlistItems]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (successProductReview) {
      alert("Review submitted");
      setRating(0);
      setComment("");
      dispatch({ type: PRODUCT_REVIEW_CREATE_RESET });
    }

    dispatch(listSizes());
    dispatch(relatedListProducts(id));
    dispatch(ymalListProducts(id));
    dispatch(listProductDetails(id, false, false));

  }, [id, dispatch, successProductReview]);

  useEffect(() => {
    // Check if the product exists before tracking the event
    if (product && product._id) {
      // Fire the 'ViewContent' event when the product page is loaded
      ReactPixel.track("ViewContent", {
        content_ids: [product.sku], // Array of product IDs (required)
        content_type: "product", // Type of content being viewed (recommended)
      });
      // console.log("ViewContent tracked for product:", product.id);
      setItemPer(product.setItemsPer ?? 0)
    }
  }, [product, id]); // Re-run if product data changes


  useEffect(() => {
    // console.log("product",product);

    // console.log('product set length',productSet.length);

    // console.log('products length',product.products);

    if (
      product &&
      product.products &&
      productSet.length > 0 &&
      product.products.length > 0 &&
      productSet.length === product.products.length
    ) {
      // console.log('products length',product.products.length);

      setSelectedSizeWomen(0);
      setSelectedSizeMen(0);
    }

    if (product) {
      const price = product?.categories?.some(
        (category) => category.name === "ANKLETS"
      )
        ? isPair
          ? product.price * 2
          : product.price
        : product?.products?.some((item) => item.sku.includes("SAIA"))
          ? isPair
            ? product.price +
            product.products.find((item) => item.sku.includes("SAIA"))?.price
            : product.price
          : product.price;

      const basePrice = product?.categories?.some(
        (category) => category.name === "ANKLETS"
      )
        ? isPair
          ? product.basePrice * 2
          : product.basePrice
        : product?.products?.some((item) => item.sku.includes("SAIA"))
          ? isPair
            ? product.basePrice +
            product.products.find((item) => item.sku.includes("SAIA"))
              ?.basePrice
            : product.basePrice
          : product.basePrice;

      setPrice(price);
      setBasePrice(basePrice);
    }

  }, [productSet, product, isPair]);


  const handleAddToCart = (obj, toCart) => {

    const addToCart = () => {
      if (userInfo) {
        dispatch(addItemToCart(obj));
        // Check if the item exists in the wishlist
        const isInWishlist = wishlistItems?.some((item) => item._id === obj.product);

        if (isInWishlist) {
          dispatch(removeItemFromWishlist(obj.product));
        }
        if (toCart) {
          navigate("/cart");
        } else {
          notify("/cart", "Item Added To Cart", toast.success);
        }
      } else {
        // Guest user – store in localStorage
        const savedCart = JSON.parse(localStorage.getItem("savedCart")) || [];

        const existingItem = savedCart.find(item => item.product === obj.product);

        if (!existingItem) {
          savedCart.push(obj);
          localStorage.setItem("savedCart", JSON.stringify(savedCart));
          toast.success("Item saved to cart (login to sync)");
          window.dispatchEvent(new Event("localCartUpdated"));
          // console.log("Cart Data ---->", savedCart);
        } else {
          toast.info("Item already in cart");
        }
      }
    };

    const categories = product.categories?.map(c => c.name?.toLowerCase()) || [];
    const subcategories = product.subcategories?.map(s => s.name?.toLowerCase()) || [];

    const isListString = (list) => {
      return Array.isArray(list) && list.every(item => typeof item === 'string');
    };

    const isRings = categories.includes("rings");
    const isBracelets = categories.includes("bracelets");
    const isAnklets = categories.includes("anklets");
    const isCoupleRing = subcategories.includes("couple rings");
    const isCoupleBracelets = subcategories.includes("for couples");
    const isSets = categories.includes("jewellery sets");
    const isMale = product.gender?.toLowerCase() === "male";

    const details = productDetails.product;

    if (isSets && productSet.length > 0 && productSet.length < 2) {
      notify("#", "Please Select Min 2 Items in Customized Set", toast.error);
      return;
    }

    if (isRings && isCoupleRing && (selectedSizeMen === 0 || selectedSizeWomen === 0)) {
      notify("#", "Select Both Ring Size", toast.error);
      return;
    }

    if (isRings && isMale && selectedSizeMen === 0) {
      notify("#", "Select Ring Size", toast.error);
      return;
    }

    if ((isRings ||
      (isSets && productSet.length === 0) ||
      (isSets && productSet.length > 0 && selectedItems.some((item) => item.sku.includes("SAIR")))
    ) && !isMale && selectedSizeWomen === 0) {
      notify("#", "Select Ring Size", toast.error);
      return;
    }

    if (
      (isAnklets ||
        (isSets && productSet.length === 0 &&
          !isListString(details.products) &&
          details.products?.some(e => e.sku?.includes("SAIA"))) ||
        (isSets && productSet.length > 0 && selectedItems.some((item) => item.sku.includes("SAIA")))
      ) && selectedAnkletSize === ""
    ) {
      notify("#", "Select Anklet Size", toast.error);
      return;
    }

    if (isBracelets && isCoupleBracelets && (selectedBraceletSizeWomen === "" || selectedBraceletSizeMen === "")) {
      notify("#", "Select Both Bracelets Size", toast.error);
      return false;
    }

    if (isBracelets && isMale && selectedBraceletSizeMen === "") {
      notify("#", "Select Bracelets Size", toast.error);
      return false;
    }

    if (
      (isBracelets ||
        (isSets && productSet.length === 0 &&
          !isListString(details.products) &&
          details.products?.some(e => e.sku?.includes("SAIB"))) ||
        (isSets && productSet.length > 0 && selectedItems.some((item) => item.sku.includes("SAIB")))
      ) && !isMale && selectedBraceletSizeWomen === ""
    ) {
      notify("#", "Select Bracelets Size", toast.error);
      return false;
    }

    if (details.canImgEng && details.canBackEng) {
      if (petTypesSelected.includes(null) || petTypesSelected.length === 0 || petTypesSelected.includes('')) {
        notify("#", "Please Select Breed", toast.error);
        return;
      }

      if (breedSize.includes('')) {
        notify("#", "Please Select Size", toast.error);
        return;
      }

      if (breedAge.includes('')) {
        notify("#", "Please Select Your Pet Age", toast.error);
        return;
      }

      if (frontPetTexts.includes('')) {
        notify("#", "Enter Front Engraving Characters", toast.error);
        return;
      }

      if (backPetTexts.includes('')) {
        notify("#", "Enter Back Engraving Characters", toast.error);
        return;
      }
    }

    // All validations passed — add to cart
    addToCart();

  };

  const addItemToWishlistHandler = (productId) => {
    dispatch(addItemToWishlist(productId));
    notify("/wishlist", "Item Added To Wishlist", toast.success);
  };

  const removeItemFromWishlistHandler = (id) => {
    dispatch(removeItemFromWishlist(id));
    notify("/wishlist", "Item Removed from Wishlist", toast.error);
  };

  const handleModalOpen = (
    // sizes,
    id,
    sent,
    customized,
    customFields,
    customQuestions
  ) => {
    // onOpen();
    setIsCustomized(customized);
    setNumberOfCustomFields(customFields);
    setCustomQuestions(customQuestions);
    const initialResponses = customQuestions?.map((question) => ({
      question,
      answer: "",
    }));
    setUserResponses(initialResponses);
    // setSizes(sizes);
  };

  const handleModalOpen2 = (id, customized, customFields, customQuestions) => {
    setIsOpen(true);
    setIsCustomized(customized);
    setNumberOfCustomFields(customFields);
    setCustomQuestions(customQuestions);
    const initialResponses = customQuestions?.map((question) => ({
      question,
      answer: "",
    }));
    setUserResponses(initialResponses);
  };

  const handleResponseChange = (index, event) => {
    const newResponses = [...userResponses];
    newResponses[index].answer = event.target.value;
    setUserResponses(newResponses);
  };

  // const handleAddToCartCustom = (e) => {
  //   e.preventDefault();
  //   dispatch(
  //     addItemToCart(
  //       1,
  //       "1",
  //       id,
  //       "en",
  //       isCustomized,
  //       numberOfCustomFields,
  //       userResponses
  //     )
  //   );
  //   setIsOpen(false);
  //   notify("/cart", "Item Added To Cart", toast.success);
  // };

  const handleImgChange = (img) => {
    setMainImg(img);
  };


  const handleQuantityChange = (value) => {
    // Guest user – store in localStorage
    const savedCart = JSON.parse(localStorage.getItem("savedCart")) || [];
    const existingItem = savedCart.find(item => item.product === product._id);
    if (existingItem) {
      toast.info("Item already in cart");
    } else {
      if (value >= 1 && value <= 5) {
        setQty(value);
      }
    }

  };

  const notify = (link, content, type) =>
    type(<RouterLink to={link}>{content}</RouterLink>);

  const imageStyle = {
    transform: `scale(${zoom})`,
    transition: isZoomed ? "transform 0.5s" : "none",
    marginLeft: "auto",
    marginRight: "auto",
    display: "block",
    transformOrigin: `${imagePosition.x}% ${imagePosition.y}%`,
  };

  const handleMouseOut = () => {
    setZoom(1);
    setIsZoomed(false);
    setImagePosition({ x: 0, y: 0 });
  };

  const handleMouseMove = (e) => {
    const image = e.target;
    const imageRect = image.getBoundingClientRect();
    const x = ((e.clientX - imageRect.left) / imageRect.width) * 100;
    const y = ((e.clientY - imageRect.top) / imageRect.height) * 100;
    setImagePosition({ x, y });
  };

  const handleTouchStart = () => {
    setZoom(2.5);
    setIsZoomed(true);
  };

  const handleTouchOut = (e) => {
    e.preventDefault();

    setZoom(1);
    setIsZoomed(false);
    setImagePosition({ x: 0, y: 0 });
  };

  const handleTouchMove = (e) => {
    e.stopPropagation();
    const image = e.target;
    const imageRect = image.getBoundingClientRect();
    const x = ((e.touches[0].clientX - imageRect.left) / imageRect.width) * 100;
    const y = ((e.touches[0].clientY - imageRect.top) / imageRect.height) * 100;
    setImagePosition({ x, y });
  };

  function isValidPinCode(str) {
    let regex = new RegExp(/^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/);
    if (str == null) {
      return "false";
    }
    if (regex.test(str) == true) {
      return true;
    } else {
      return false;
    }
  }

  const handlePinCodeChange = (e) => {
    setPinCode(e.target.value);
  };

  const handleCheckDelivery = async () => {
    try {
      let result = isValidPinCode(pinCode);
      if (result) {
        setIsDeliveryAvailable(result);
      } else {
        setIsDeliveryAvailable(false);
        throw new Error("Please check entered Pincode");
      }
    } catch (error) {
      console.error("Error checking delivery:", error);
      setIsDeliveryAvailable(false);
    }
  };

  // -------jewellery set here--------

  const totalPrice = selectedItems.reduce((sum, item) => {
    const price = item.sku.includes("SAIA")
      ? isPair
        ? item.itemPrice * 2
        : item.itemPrice
      : item.itemPrice;
    return sum + price;
  }, 0);

  const totalBasePrice = selectedItemBasePrice.reduce((sum, item) => {
    const basePrice = item.sku.includes("SAIA")
      ? isPair
        ? item.itemBasePrice * 2
        : item.itemBasePrice
      : item.itemBasePrice;

    return sum + basePrice;
  }, 0);

  useEffect(() => {
    let overallDiscount = Number(
      (
        ((product.basePrice - product.price) / product.basePrice) *
        100
      )?.toFixed(0)
    );

    if (selectedItems.length < 2) {
      console.log(totalPrice);
      setfinalAmount(totalPrice);
    } else {
      console.log("total price", totalBasePrice);
      console.log("total price", itemPer);
      let extraDiscount = (selectedItemBasePrice.length - 1) * itemPer;
      let finalDiscount = overallDiscount + extraDiscount;
      let discountedPrice = Number(
        // (totalBasePrice - (totalBasePrice * finalDiscount) / 100).toFixed(0)
        (totalBasePrice - ((finalDiscount / 100) * totalBasePrice)).toFixed(0)
      );

      setfinalAmount(discountedPrice);
    }
  }, [selectedItemBasePrice, isPair]);

  //********** For Pet *************//

  const [frontPetTexts, setFrontPetTexts] = useState([]);
  const [petTypesSelected, setPetTypesSelected] = useState([]);
  const [backPetTexts, setBackPetTexts] = useState([]);
  const [breedAge, setBreedAge] = useState([]);
  const [breedSize, setBreedSize] = useState([]);

  const handlePetFrontEngChange = (text, index) => {
    const updated = [...frontPetTexts];
    updated[index] = text;
    setFrontPetTexts(updated);
  };

  const handlePetTypeChange = (pet, index) => {
    const updated = [...petTypesSelected];
    updated[index] = pet;
    setPetTypesSelected(updated);
  };

  const handlePetBackEngChange = (text, index) => {
    const updated = [...backPetTexts];
    updated[index] = text;
    setBackPetTexts(updated);
  };

  const handleBreedAgeChange = (text, index) => {
    const updated = [...breedAge];
    updated[index] = text;
    setBreedAge(updated);
  };

  const handleBreedSizeChange = (text, index) => {
    const updated = [...breedSize];
    updated[index] = text;
    setBreedSize(updated);
  };


  useEffect(() => {
    // console.log("In Effect", product);
    if (
      product &&
      product.productCollections?.some(cat => cat.name === "Pet Collection") &&
      product.canEngrave && product.canBackEng
    ) {
      const q = qty || 1;

      // console.log("In Use Effect", q);

      setFrontPetTexts(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });

      setPetTypesSelected(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push(null);
        return updated.slice(0, q);
      });

      setBackPetTexts(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });

      setBreedAge(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });

      setBreedSize(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });
    }
  }, [qty]);

  return (
    <div className="">

      <section className="bg-white font-poppins">
        {loading ? (
          <div>Loading</div>
        ) : error ? (
          <div class="text-center font-bold">Product not found</div>
        ) : (
          <div className="max-w-7xl px-4 py-4 mx-auto md:px-12">
            <Helmet>
              <title>{product.prodTitle || product.name}</title>
              <meta name="description" content={product.prodMetaDesc} />
              <meta
                property="og:image"
                content={
                  product.variants?.filter((obj) => obj._id === variantId)[0]
                    ?.images[0]
                }
              />
              <meta property="og:image:alt" content="Product Image" />
              <meta property="og:image:type" content="image/jpeg" />
              <meta property="og:image:width" content="1200" />
              <meta property="og:image:height" content="630" />

            </Helmet>
            <div className="flex items-center space-x-4 mb-2">
              <WishlistToggleButton product={product} showLabel={true} className="block md:hidden" />
              <ShareButton showLabel={true} className="block md:hidden" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 -mx-4">


              <div className="w-full px-4 md:px-8 sticky top-0">

                <ProductImages product={product} variantId={variantId} />
              </div>
              <div className="w-full px-4 md:px-8">
                <div className="sticky top-0">
                  <div className="flex flex-col gap-4 mb-3 md:mb-6">
                    <div className="flex gap-4 items-center pt-5 md:pt-0">
                      <h2 className="text-lg font-bold md:text-lg">
                        {product.name}
                      </h2>

                      <WishlistToggleButton product={product} className="hidden md:block" />
                      <ShareButton className="hidden md:block" />
                    </div>
                    <h3>SKU - {product?.sku}</h3>
                    <p className="mt-2 text-[12px] text-gray-400 text-justify">
                      {product.metaDescription}
                    </p>
                    <div className="flex gap-2 items-end">
                      <p className="inline-block p-1 text-2xl font-semibold text-black">
                        <span>
                          ₹ {price?.toLocaleString("en-IN")}

                        </span>
                      </p>
                      <p
                        className={`inline-block p-1 text-lg line-through text-gray-400 ${product.basePrice === 0 ? "hidden" : ""
                          }`}
                      >
                        <span>
                          ₹{" "}

                          {basePrice?.toLocaleString("en-IN")}
                        </span>
                      </p>
                      <p
                        className={`${product.discountedPercent === 0 ? "hidden" : ""
                          } inline-block p-1 text-lg text-[#000080]`}
                      >
                        -
                        {(
                          ((product.basePrice - product.price) /
                            product.basePrice) *
                          100
                        )?.toFixed(0)}
                        %
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-col gap-6 mb-6">

                    <Quantity
                      qty={qty}
                      handleQuantityChange={handleQuantityChange}
                    />

                    {/* Rings */}

                    {allowRingSize ||
                      (product?.products?.some((item) =>
                        item.sku.toUpperCase().includes("SAIR")
                      ) &&
                        productSet.length === 0) ||
                      product?.categories?.some(
                        (cat) => cat.name.toLowerCase() === "rings"
                      ) ? <RingSizeSelector
                      loadingSize={loadingSize}
                      errorSize={errorSize}
                      sizes={sizes}
                      selectedProduct={product}
                      selectedSizeMen={selectedSizeMen}
                      setSelectedSizeMen={setSelectedSizeMen}
                      selectedSizeWomen={selectedSizeWomen}
                      setSelectedSizeWomen={setSelectedSizeWomen}

                    /> : null}


                    {/* For Anklets */}
                    {allowAnkletType ||
                      (product?.products?.some((item) =>
                        item.sku.toUpperCase().includes("SAIA")
                      ) &&
                        productSet.length === 0) ||
                      product?.categories?.some(
                        (cat) => cat.name === "ANKLETS"
                      ) ? (
                      <AnkletSizeSelector
                        value={selectedAnkletSize}
                        onChange={(e) => setSelectedAnkletSize(e.target.value)}
                        isPair={isPair}
                        setIsPair={setIsPair}
                      />

                    ) : null}

                    {/* Bracelet Size */}

                    {allowBraceletSize ||
                      (product?.products?.some((item) =>
                        item.sku.toUpperCase().includes("SAIB")
                      ) &&
                        productSet.length === 0) ||
                      product?.categories?.some(
                        (cat) => cat.name === "BRACELETS"
                      )

                      ? <BraceletSizeSelector
                        selectedProduct={product}
                        selectedBraceletSizeMen={selectedBraceletSizeMen}
                        setSelectedBraceletSizeMen={setSelectedBraceletSizeMen}
                        selectedBraceletSizeWomen={selectedBraceletSizeWomen}
                        setSelectedBraceletSizeWomen={
                          setSelectedBraceletSizeWomen}
                      />
                      : null}

                    {/* Jewellery Sets */}
                    {product?.categories?.some(
                      (cat) => cat.name == "JEWELLERY SETS"
                    ) ? (
                      <ProductSet2
                        product={product}
                        variantId={variantId}
                        productSet={productSet}
                        setProductSet={setProductSet}
                        selectedItems={selectedItems}
                        setSelectedItems={setSelectedItems}
                        selectedItemBasePrice={selectedItemBasePrice}
                        setSelectedItemBasePrice={setSelectedItemBasePrice}
                        totalPrice={finalAmount}
                        totalbasePrice={totalBasePrice}
                        allowRingSize={allowRingSize}
                        setAllowRingSize={setAllowRingSize}
                        allowBraceletSize={allowBraceletSize}
                        setAllowBraceletSize={setAllowBraceletSize}
                        allowAnkletType={allowAnkletType}
                        setAllowAnkletType={setAllowAnkletType}
                        isPair={isPair}
                        setIsPair={setIsPair}
                      />
                    ) : null}

                    <EngravingSection
                      product={product}
                      engravingTextMen={engravingTextMen}
                      engravingTextWomen={engravingTextWomen}
                      allowRingSize={allowRingSize}
                      productSet={productSet}
                      isAccordionOpen={isAccordionOpen}
                      handleAccordionToggle={handleAccordionToggle}
                      handleEngravingInput={handleEngravingInput}
                    />

                    {product?.productCollections?.some(cat => cat.name === "Pet Collection") &&
                      product?.canEngrave && product?.canBackEng &&
                      [...Array(qty || 1)].map((_, index) => (

                        <PetEngraving
                          key={index}
                          index={index}
                          product={product}
                          selectedPetType={petTypesSelected[index]}
                          setSelectedPetType={(pet) => handlePetTypeChange(pet, index)}
                          frontPetText={frontPetTexts[index]}
                          handlePetFrontEngChange={(text) => handlePetFrontEngChange(text, index)}
                          backPetText={backPetTexts[index]}
                          handlePetBackEngChange={(text) => handlePetBackEngChange(text, index)}
                          breedAge={breedAge[index]}
                          handleBreedAgeChange={(text) => handleBreedAgeChange(text, index)}
                          breedSize={breedSize[index]}
                          handleBreedSizeChange={(text) => handleBreedSizeChange(text, index)}
                        />
                      ))}
                  </div>

                  <div className="flex gap-2 mb-6">
                    <div className="w-1/2 group">
                      <button
                        className="flex rounded-3xl items-center justify-center w-full p-2 text-lg border rounded-md enbaled:cursor-pointer disabled:cursor-not-allowed bg-[#000080] border-[#000080] text-gray-100"

                        onClick={() => {
                          // if (userInfo && userInfo.firstName) {
                          handleAddToCart(
                            {
                              name: product.name,
                              image:
                                product.variants?.length > 0 &&
                                product.variants?.filter(
                                  (variant) => variant._id === variantId
                                )[0]?.images[0],
                              qty,
                              sizeMen: selectedSizeMen,
                              sizeWomen: selectedSizeWomen,
                              price:
                                productSet.length > 0
                                  ? finalAmount
                                  : product?.products?.some((item) =>
                                    item.sku.includes("SAIA")
                                  )
                                    ? price
                                    : product.price,
                              basePrice:
                                productSet.length > 0
                                  ? totalBasePrice
                                  : product?.products?.some((item) =>
                                    item.sku.includes("SAIA")
                                  )
                                    ? basePrice
                                    : product.basePrice,
                              product: product._id,
                              products: productSet,
                              variant: variantId,
                              sku: product.sku,
                              giftWrap: false,
                              message: "",
                              engraveMen: engravingTextMen,
                              engraveWomen: engravingTextWomen,
                              isPair,
                              braceletsSizeMen: selectedBraceletSizeMen,
                              braceletsSizeWomen: selectedBraceletSizeWomen,
                              ankletsSize: selectedAnkletSize,
                              petFrontEng: frontPetTexts,
                              petBackEng: backPetTexts,
                              petEngImage: petTypesSelected,
                              breedAge: breedAge,
                              breedSize: breedSize,
                            },

                            false
                          );
                          // } else {
                          //   navigate("/signup");
                          // }
                        }}
                      >
                        Add to Cart
                        <AiOutlineShoppingCart className="ml-1 mb-1 animate-twice animate-jump animate-ease-in-out" />
                      </button>
                    </div>
                    <div className="w-1/2">

                      <button
                        className="flex rounded-3xl items-center justify-center w-full p-2 text-[#000080] text-lg border border-[#000080] rounded-md hover:bg-[#000080] hover:border-[#000080] hover:text-gray-100"

                        onClick={() => {
                          if (userInfo && userInfo.firstName) {
                            handleAddToCart(
                              {
                                name: product.name,
                                image:
                                  product.variants?.length > 0 &&
                                  product.variants?.filter(
                                    (variant) => variant._id === variantId
                                  )[0]?.images[0],
                                qty,
                                sizeMen: selectedSizeMen,
                                sizeWomen: selectedSizeWomen,
                                price:
                                  productSet.length > 0
                                    ? finalAmount
                                    : product?.products?.some((item) =>
                                      item.sku.includes("SAIA")
                                    )
                                      ? price
                                      : product.price,
                                basePrice:
                                  productSet.length > 0
                                    ? totalBasePrice
                                    : product?.products?.some((item) =>
                                      item.sku.includes("SAIA")
                                    )
                                      ? basePrice
                                      : product.basePrice,
                                product: product._id,
                                products: productSet,
                                variant: variantId,
                                sku: product.sku,
                                giftWrap: false,
                                message: "",
                                engraveMen: engravingTextMen,
                                engraveWomen: engravingTextWomen,
                                isPair,
                                braceletsSizeMen: selectedBraceletSizeMen,
                                braceletsSizeWomen: selectedBraceletSizeWomen,
                                ankletsSize: selectedAnkletSize,
                                petFrontEng: frontPetTexts,
                                petBackEng: backPetTexts,
                                petEngImage: petTypesSelected,
                                breedAge: breedAge,
                                breedSize: breedSize,
                              },
                              true
                            );
                          } else {
                            navigate("/signup");
                          }
                        }}
                      >
                        Buy Now
                      </button>
                    </div>
                  </div>

                  <div>
                    <h1 className="font-semibold">Select Plating Color</h1>
                    <div className="flex gap-4 p-4 justify-center items-center">
                      {product?.variants?.map((variant) => (
                        <div
                          className={`w-1/4 aspect-[1] border ${variantId === variant._id
                            ? "border-[#000080] border-2"
                            : ""
                            }`}
                        >
                          <RouterLink
                            to={`/product/${product.name?.replaceAll(
                              " ",
                              "-"
                            )}/${product._id}?variant=${variant?._id}`}
                          >
                            <img
                              src={variant?.images[0]}
                              alt={variant?.color}
                            />
                          </RouterLink>
                        </div>
                      ))}
                    </div>
                  </div>

                  <FeatureBanner />

                  <Accordion allowMultiple>
                    <AccordionItem>
                      <h2>
                        <AccordionButton>
                          <Box as="span" flex="1" textAlign="left">
                            Product Description
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                      </h2>
                      <AccordionPanel pb={4} className="whitespace-pre-line">
                        {product.description}
                      </AccordionPanel>
                    </AccordionItem>

                    <AccordionItem>
                      <h2>
                        <AccordionButton>
                          <Box as="span" flex="1" textAlign="left">
                            Free Delivery
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                      </h2>
                      <AccordionPanel pb={4}>
                        Free Delivery All Over India
                      </AccordionPanel>
                    </AccordionItem>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
      <div className="max-w-6xl px-0 md:px-4 py-4 mx-auto ">
        <PromoProductCard
          name={"GOES WELL WITH"}
          products={productsYmal}
          sts={productsYmal?.length}
          loading={loadingYmal}
          error={errorYmal}
        />
        <PromoProductCard
          name={"RELATED PRODUCTS"}
          products={productsRelated}
          sts={productsRelated?.length}
          loading={loadingRelated}
          error={errorRelated}
        />
      </div>
    </div>
  );
}
